module.exports = __webpack_public_path__ + "img/wood.81a0682a.png";